import { getRequest, postRequest } from '../baseRequest'
import request from '@/api/index'
import { filterEmptyParams } from '@/utils/formatObject'


// 分页查询工单列表
export const getWorkOrderList = (data) => postRequest('/workOrder/queryPage', filterEmptyParams(data))
// 查询工单详情
export const getWorkOrderDetail = (params) => getRequest(`/workOrder/detail`, params)
// 批量关闭工单
export const handleBatchCloseWorkOrder = (data) => postRequest('/workOrder/batchCloseWorkOrder', data)
// 批量关闭工单
export const submitRecord = (data) => postRequest('/workOrder/submitRecord', data)
// 导出
export const exportWorkOrders = (data) => {
  return request({
    url: '/workOrder/exportWorkOrders',
    method: 'post',
    data: filterEmptyParams(data),
    responseType: 'blob'
  })
}

